<template>
  <Grid gtc="200px 1fr" class="vendor-payments overflow-hidden relative-position">
    <template v-if="quickViewItems">
      <ModalSidebar ref="modalSidebar" :items="quickViewItems" @item-selected="openQuickView" />

      <Grid gtr="1fr auto" class="overflow-hidden">
        <ModalBody>
          <div v-if="quickView" :key="quickView.provider.id" class="q-pa-lg bg-white-1 shadow3 border-radius-sm">
            <div class="text-heading-1 text-secondary-2">{{ quickView.provider.name }}</div>

            <InvoicesTable :invoices.sync="quickView.vendor_invoices" @finalized="onFinalized" />
          </div>
        </ModalBody>
      </Grid>
    </template>
  </Grid>
</template>

<script>
import * as apiTo from '@/modular-api'
import { getTaskData, setSubtitle, openQuickView } from '@/reusable/workflow/task-modals/modals-shared'
// Components
import ModalSidebar from '../components/ModalSidebar'
import ModalBody from '../components/ModalBody'
import InvoicesTable from './components/invoices-table/InvoicesTable'

export default {
  components: {
    ModalSidebar,
    ModalBody,
    InvoicesTable
  },

  props: {
    periodId: [Number, String]
  },

  data: () => ({
    quickViewItems: null,
    quickView: null
  }),

  watch: {
    quickViewItems: 'setSubtitle'
  },

  created() {
    this.getTaskData('vendor-payments').then(({ data }) => (this.quickViewItems = data.result))
  },

  methods: {
    getTaskData,
    setSubtitle: setSubtitle('Vendors'),
    openQuickView: openQuickView('vendor-payments'),

    getCount() {
      return this.quickViewItems.reduce((acc, curr) => {
        acc += curr.invoice_count
        return acc
      }, 0)
    },

    onFinalized(data) {
      this.$emit('set-loader', true)

      apiTo
        .PROCESS_TASK('vendor-payments', data.id, data)
        .then(() => {
          const lastItemInTable = this.quickView.vendor_invoices.length === 1
          const lastItemInSidebar = this.quickViewItems.length === 1 && lastItemInTable

          if (lastItemInSidebar) this.$emit('make-count-0')
          else if (lastItemInTable) this.moveToNextSidebarItem()
          else {
            const index = this.quickView.vendor_invoices.findIndex(v => v.id === data.id)
            if (~index) {
              this.quickView.vendor_invoices.splice(index, 1)
              const quickViewItem = this.quickViewItems.find(v => v.id === this.quickView.provider.id)
              if (quickViewItem) quickViewItem.invoice_count--
            }
          }
        })
        .finally(() => this.$emit('set-loader', false))
    },

    moveToNextSidebarItem() {
      const index = this.quickViewItems.findIndex(g => g.id === this.quickView.provider.id)
      if (~index) this.quickViewItems.splice(index, 1)

      const activeIndex = this.$refs.modalSidebar.getSelectedIndex()

      if (activeIndex === 0) this.$refs.modalSidebar.onItemSelected(0)
      else this.$refs.modalSidebar.setSelectedIndex(activeIndex - 1)
    }
  }
}
</script>
